import { Layer, Source } from '@vis.gl/react-maplibre';

import { BEFORE_LABEL_ID } from '@/modules/BeforeLabelsId';
import { TILES_PATH } from '@/modules/TILES_PATH';

const STATE_BORDER_LAYER = 'STATE_BORDER_LAYER';

export function StateBorderLayer() {
  return (
    <Source id={STATE_BORDER_LAYER} type="vector" url={`${TILES_PATH}/state_border`}>
      <Layer
        beforeId={BEFORE_LABEL_ID}
        id={STATE_BORDER_LAYER}
        source-layer="state_border"
        type="fill"
        paint={{
          'fill-opacity': 0.25,
          'fill-color': 'black',
        }}
      />
    </Source>
  );
}
